import reconSummaryTemplate from "./reconSummary.template.html";

/*******************************************************************************
 * Component: BankReconSummaryComponent */
/**
 * @ngdoc   component
 * @module  csm.books.BankRecon
 * @name    csm.books.BankRecon.component:reconSummary
 *
 * @param  {Object}  statement  Bank Statement containing the money values for
 *                              the summary.
 *
 * @description
 * Displays the Bank Reconciliation summary view. The provided statement object
 * is for the beginning and ending balances, and calculates the other values from
 * the items of the statement object.
 *******************************************************************************/
export const bankReconSummaryComponent = {
  template: reconSummaryTemplate,
  controller: BankReconSummaryController,
  bindings: { statement: '<' }
}

/*******************************************************************************
 * Controller: BankReconSummaryController */
/**
 * @ngdoc   controller
 * @module  csm.books.BankRecon
 * @name    csm.books.BankRecon.controller:BankReconSummary
 * @description
 * This is the controller for the
 * {@link csm.books.BankRecon.component:reconSummary reconSummary} component.
 *******************************************************************************/
/* @ngInject */ function BankReconSummaryController(SERVER) {
  /** Self reference. */ var mThis = this;
  /** Checks label. */ mThis.checksLabel =
    SERVER.BooksWebConstants.checksLabel;
  /** Deposits label. */ mThis.depositsLabel =
    SERVER.BooksWebConstants.depositsLabel;
}
